import type { Location } from '@/model/location.model.ts'
import type { Nullish } from '@logistiek-zonder-papier/lzp-library'

export function decodeHtmlEntities(str: string | Nullish): string {
  if (!str) return str ?? ''

  const txt = document.createElement('textarea')
  let current = str
  let previous: string

  do {
    previous = current
    txt.innerHTML = previous
    current = txt.value
  } while (current !== previous)

  return current
}

export function decodeLocation(location: Location): Location {
  return {
    ...location,
    naam: decodeHtmlEntities(location.naam),
    straatnaam: decodeHtmlEntities(location.straatnaam),
    huisNummer: decodeHtmlEntities(location.huisNummer),
    toevoeging: decodeHtmlEntities(location.toevoeging),
    postcode: decodeHtmlEntities(location.postcode),
    stad: decodeHtmlEntities(location.stad),
    land: decodeHtmlEntities(location.land),
    vestigingsNummer: decodeHtmlEntities(location.vestigingsNummer),
  }
}
